import { ArrowBack } from '@mui/icons-material';
import {
	Box,
	Button,
	Container,
	Divider,
	Link,
	// Link,
	Stack,
	Typography,
} from '@mui/material';
import { get } from 'lodash';
import React, { FC, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LoadingBackdrop from '../../../../components/ui-component/loading/LoadingBackdrop';
import CreateNachricht from '../../../../components/ui-component/nachrichten/CreateNachricht';
import NoDetailsInfo from '../../../../components/ui-component/no-details-info/NoDetailsInfo';
import { useFetchNachrichtenDetails } from '../../../../hooks/FetchNachrichten';
import { APIS } from '../../../../lib/constants/apis';
import { PAGES_URLS } from '../../../../lib/constants/routes';

// import Schemas
import MarkdownRenderer from '../../../../components/ui-component/markdown-renderer/MarkdownRenderer';
import Schema from '../../../../lib/paths/nachricht_FULL_Paths.json';
let P = Schema.attributes;

const NachrichtenDetails: FC<{}> = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const numericId = get(location, 'state.id');

	const { loading, data, error } = useFetchNachrichtenDetails(numericId);

	const [openMessage, setOpenMessage] = useState(false);

	if (!numericId) return <NoDetailsInfo title='Nachricht' goBackUrl={PAGES_URLS.Nachrichten} />;
	if (error) console.error(' error', error);
	if (loading) return <LoadingBackdrop />;

	return (
		<>
			<Container>
				<CreateNachricht
					showNachrichtDialog={openMessage}
					handleCloseDialog={() => setOpenMessage(false)}
					applications={[get(data, P.Antrag.path)]}
					isReply={true}
					nachrichtId={get(data, 'id')}
					originalTitle={get(data, P.Allgemein_Betreff.path)}
					originalContent={get(data, P.Allgemein_Inhalt.path)}
				/>
				<Stack spacing={3}>
					<Stack direction={'row'} justifyContent={'space-between'}>
						<Button variant={'outlined'} startIcon={<ArrowBack />} onClick={() => navigate(PAGES_URLS.Nachrichten)}>
							Zurück zu meinen Nachrichten
						</Button>
						{get(data, P.Allgemein_Ordner.path) === 'Posteingang' && <Button onClick={() => setOpenMessage(true)}>Antworten</Button>}
					</Stack>
					<Stack spacing={3}>
						<Typography variant='h3' component='h2'>
							{'Betreff: ' + get(data, P.Allgemein_Betreff.path)}
						</Typography>
						<Box>
							{get(data, P.Allgemein_Ordner.path) === 'Posteingang' ?
								<Typography>Von: VDMK</Typography>
							:	<Typography>
									Von: {get(data, P.Antragsteller.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path, '')}
								</Typography>
							}

							<Typography>
								Antrag:{' '}
								<Link
									sx={{ cursor: 'pointer', textDecoration: 'unterlinde' }}
									onClick={() => {
										navigate(`${PAGES_URLS.FoerderDashboard}`, {
											state: {
												id: get(data, `${P.Antrag.path}.id`),
												api: APIS.Antrag,
											},
										});
									}}
								>
									{get(data, P.Antrag.schema.attributes.Zusammenfassung_Ueberblick_Titel.path)}
								</Link>{' '}
							</Typography>
						</Box>
						<Divider />
						<Typography component={'div'}>
							<MarkdownRenderer markdown={get(data, P.Allgemein_Inhalt.path)} />
						</Typography>
					</Stack>
				</Stack>
			</Container>
		</>
	);
};
export default NachrichtenDetails;
